import { BuildingConfig, BuildingOptions } from './types';

export const convertDefaultModelsToBuildingOptions = (
  config: BuildingConfig,
): BuildingOptions => ({
  modelId: config.name,
  withFloors: config.withFloors,
  coordinates: config.coords,
  linkedIds: config.buildingIds,
  scale: config.scale,
  rotateX: config.rotateX * 180,
  rotateY: config.rotateY * 180,
  offsetX: config.moveX / 100,
  offsetY: config.moveY / 100,
  offsetZ: config.moveZ / 100,
  modelUrl: config.path,
});
